// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reply-editor{display:block;position:relative}.reply-editor wcc-droparea{min-height:50px !important}.reply-editor wcc-droparea .droparea-label{font-size:18px;white-space:nowrap}.reply-editor wcc-droparea .droparea-label p{display:inline-block;line-height:50px;margin-bottom:0;margin-right:10px}.reply-editor wcc-droparea .droparea-label .glyphicons{font-size:30px !important}", ""]);
// Exports
module.exports = exports;
